// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q0scmm0 {
  width: 100%!important;
}
.q0scmm1 {
  transform: translate(100%);
}
.q0scmm2 {
  transform: translate(0px);
}
.q0scmm3 {
  align-items: center;
  background-color: var(--_18w76bw26);
  z-index: 1000;
}
@media screen and (min-width: 768px) {
  .q0scmm0 {
    width: 320px!important;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;AACf;AACA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".q0scmm0 {\n  width: 100%!important;\n}\n.q0scmm1 {\n  transform: translate(100%);\n}\n.q0scmm2 {\n  transform: translate(0px);\n}\n.q0scmm3 {\n  align-items: center;\n  background-color: var(--_18w76bw26);\n  z-index: 1000;\n}\n@media screen and (min-width: 768px) {\n  .q0scmm0 {\n    width: 320px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
